export default "__VITE_ASSET__CBCa6Dkc__"